import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const CashReceivedList = () => {
    const [cashReceived, setCashReceived] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredCashReceived, setFilteredCashReceived] = useState([]);
    const navigate = useNavigate();

    // Fetch cash received data when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}cashreceived`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setCashReceived(data.data);
                    setFilteredCashReceived(data.data); // Set initial filtered data
                } else {
                    alert('Failed to fetch cash received entries');
                }
            })
            .catch(error => console.error('Error fetching cash received data:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter cash received based on the search term
        const filtered = cashReceived.filter(entry =>
            entry.description.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredCashReceived(filtered);
    };

    // Navigate to the edit page for cash received
    const handleEdit = (id) => {
        navigate(`/EditCashReceived/${id}`);
    };

    // Handle deletion (if needed)
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this entry?")) {
            fetch(`${BASE_URL}cashreceived/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        // Remove deleted entry from both lists
                        setCashReceived(cashReceived.filter(entry => entry.id !== id));
                        setFilteredCashReceived(filteredCashReceived.filter(entry => entry.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting entry:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Cash Received List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                    {/* Breadcrumbs if needed */}
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="searchTerm" className="form-label">Search by Description</label>
                                        <input
                                            type="text"
                                            id="searchTerm"
                                            className="form-control"
                                            placeholder="Search by description"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button 
                                            className="btn btn-primary"
                                            onClick={() => navigate('/AddCashReceived')}
                                        >
                                            Add Cash Received
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Staff ID</th>
                                                <th>Customer ID</th>
                                                <th>Amount</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredCashReceived.map(entry => (
                                                <tr key={entry.id}>
                                                    <td>{entry.id}</td>
                                                    <td>{entry.staff_id}</td>
                                                    <td>{entry.c_id}</td>
                                                    <td>{entry.amount}</td>
                                                    <td>{entry.description}</td>
                                                    <td>{new Date(entry.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(entry.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(entry.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CashReceivedList;
